var map = {
	"./data": 3643,
	"./data.json": 3643,
	"./database": 946,
	"./database.json": 946,
	"./images/banner.jpg": 8900,
	"./images/comp.jpg": 3372,
	"./images/fabio-oyXis2kALVg-unsplash.jpg": 2574,
	"./images/favicon.ico": 6375,
	"./images/img1.jpg": 1781,
	"./images/img2.jpg": 5644,
	"./images/img3.jpg": 3527,
	"./images/img4.jpg": 3577,
	"./images/img5.jpg": 5433,
	"./images/img6.jpg": 7594,
	"./images/lectures.jpg": 6776,
	"./images/pic01.jpg": 518,
	"./images/pic02.jpg": 5371,
	"./images/pic03.jpg": 5083,
	"./images/pic04.jpg": 7845,
	"./images/pic05.jpg": 6071,
	"./images/pic06.jpg": 9664,
	"./images/pic07.jpg": 1026,
	"./images/pic08.jpg": 5144,
	"./images/project.jpg": 312,
	"./images/projects/summer13/3dc.jpg": 1267,
	"./images/projects/summer13/aq.jpg": 9104,
	"./images/projects/summer13/at.jpg": 1310,
	"./images/projects/summer13/au.jpg": 6708,
	"./images/projects/summer13/aw.jpg": 892,
	"./images/projects/summer13/cc.jpg": 8751,
	"./images/projects/summer13/eg.jpg": 865,
	"./images/projects/summer13/em.jpg": 3000,
	"./images/projects/summer13/fc.jpg": 7460,
	"./images/projects/summer13/gc.jpg": 4114,
	"./images/projects/summer13/hw.jpg": 5727,
	"./images/projects/summer13/kdb.jpg": 4054,
	"./images/projects/summer13/mf.jpg": 3647,
	"./images/projects/summer13/sbp.jpg": 7137,
	"./images/projects/summer13/ss.jpg": 8461,
	"./images/projects/summer13/tr.jpg": 6122,
	"./images/projects/summer14/3d_laser_scanner.webp": 5565,
	"./images/projects/summer14/CameraSurveillance.webp": 1348,
	"./images/projects/summer14/PET.webp": 8296,
	"./images/projects/summer14/auraplay.webp": 1235,
	"./images/projects/summer14/conway.webp": 9289,
	"./images/projects/summer14/fitness_sleep.webp": 8111,
	"./images/projects/summer14/fpga_music.jpg": 8971,
	"./images/projects/summer14/fpga_music.webp": 6841,
	"./images/projects/summer14/lasertag.webp": 6735,
	"./images/projects/summer15/SocialRobot.jpg": 4202,
	"./images/projects/summer15/SocialRobotp.jpg": 8361,
	"./images/projects/summer15/emg.jpg": 6048,
	"./images/projects/summer15/emgp.jpg": 38,
	"./images/projects/summer15/fpga.jpg": 6919,
	"./images/projects/summer15/fpgap.jpg": 8812,
	"./images/projects/summer15/hand.jpg": 1079,
	"./images/projects/summer15/handp.jpg": 1241,
	"./images/projects/summer15/handshake.jpg": 2686,
	"./images/projects/summer15/handshakep.pdf": 412,
	"./images/projects/summer15/lock.jpg": 6910,
	"./images/projects/summer15/lockp.jpg": 8314,
	"./images/projects/summer15/mood.jpg": 7198,
	"./images/projects/summer15/moodp.jpg": 1024,
	"./images/projects/summer16/hand.png": 1607,
	"./images/projects/summer16/kinects.jpg": 9083,
	"./images/projects/summer16/wifi.jpg": 5680,
	"./images/projects/summer17/bci.png": 4601,
	"./images/projects/summer17/hdmi.jpg": 8448,
	"./images/projects/summer17/stereo.png": 5563,
	"./images/projects/summer17/swarm.jpg": 3052,
	"./images/projects/summer18/1.jpg": 3272,
	"./images/projects/summer18/2.jpg": 7912,
	"./images/projects/summer18/3.jpg": 51,
	"./images/projects/summer18/4.jpg": 2453,
	"./images/projects/summer18/5.png": 7169,
	"./images/projects/summer19/1.jpg": 9389,
	"./images/projects/summer19/2.jpg": 8467,
	"./images/projects/summer19/3.png": 2835,
	"./images/projects/summer19/4.png": 4622,
	"./images/projects/summer19/5.png": 3681,
	"./images/projects/summer19/6.png": 6673,
	"./images/projects/summer23/eeg.webp": 1688,
	"./images/projects/summer23/fieldingrobo.jpg": 7876,
	"./images/projects/summer23/maglev.jpg": 9309,
	"./images/projects/summer23/telepresence.jpg": 4410,
	"./images/projects/summer23/virtualclothing.png": 3378,
	"./images/takneek.jpg": 6632,
	"./images/techkriti.jpg": 8514,
	"./images/w logo.jpg": 8317,
	"./images/workshop.jpg": 760,
	"./lectures/2017/Takneek'17 lecture.pdf": 8059,
	"./lectures/2017/lecture1.pdf": 7748,
	"./lectures/Analog.pdf": 7427,
	"./lectures/FPGA2017.pdf": 4652,
	"./lectures/Takneek 13/Verilog.pdf": 5650,
	"./lectures/Takneek 13/electromania.pdf": 13,
	"./lectures/Techkriti 15/MCU.pdf": 5051,
	"./lectures/Techkriti 15/Techkriti15.pdf": 1564,
	"./lectures/Techkriti 16/Electromania-lecture.pdf": 9600,
	"./lectures/Techkriti 17/electromania17.pdf": 5279,
	"./lectures/Techkriti 17/embedded17.pdf": 6414,
	"./lectures/aad11/aad.pdf": 4409,
	"./lectures/aad11/secondActivity.java": 8174,
	"./lectures/embedded 13/Arduino.pdf": 6018,
	"./lectures/embedded 13/Communication.pdf": 6287,
	"./lectures/embedded 13/SkeletonBasics-WPF.zip": 7434,
	"./lectures/embedded 13/fpga.pdf": 7197,
	"./lectures/embedded 13/kinect_new.pdf": 5029,
	"./lectures/embedded/Embedded-New-1.pdf": 1694,
	"./lectures/embedded/Embedded-New-2.pdf": 3120,
	"./lectures/embedded/Embedded-New-3.pdf": 7088,
	"./lectures/embedded/Embedded-Old-1.pdf": 9182,
	"./lectures/embedded/Embedded-Old-2.pdf": 5490,
	"./lectures/embedded/Embedded-Old-3.pdf": 6753,
	"./lectures/embedded/Embedded-Old-4.pdf": 5821,
	"./lectures/embedded12/accelerometer.zip": 5332,
	"./lectures/embedded12/adc.pdf": 562,
	"./lectures/embedded12/android.pdf": 8008,
	"./lectures/embedded12/communication.pdf": 5253,
	"./lectures/embedded12/kinect.pdf": 537,
	"./lectures/embedded14/IP.pdf": 6083,
	"./lectures/embedded14/arduino.pdf": 3161,
	"./lectures/embedded14/comm.pdf": 4663,
	"./lectures/embedded14/fpga.pdf": 7260,
	"./lectures/embedded14/kinect.pdf": 4759,
	"./lectures/embedded14/proc.pdf": 1445,
	"./lectures/fpga10/FPGAExamples.zip": 115,
	"./lectures/fpga10/VerilogFPGA-1.pdf": 8096,
	"./lectures/fpga10/VerilogFPGA-2.pdf": 3393,
	"./lectures/summer 13/Microcontrollers.pdf": 4234,
	"./lectures/summer 13/Timers.pdf": 8917,
	"./lectures/summer 13/arduino.pdf": 5011,
	"./lectures/summer 13/ip_2.pdf": 1257,
	"./lectures/summer 13/opencv_sample.rar": 530,
	"./lectures/summer12/adc.pdf": 2160,
	"./lectures/summer12/cvavr_and_avrstudio.pdf": 9616,
	"./lectures/summer12/introduction_to_mcu.pdf": 3810,
	"./lectures/summer12/opencv.pdf": 6415,
	"./lectures/summer12/spi.pdf": 3514,
	"./lectures/summer12/timers_and_interrupts.pdf": 2040,
	"./lectures/summer12/uart.pdf": 8346,
	"./lectures/summer14/MCU.pdf": 9229,
	"./lectures/summer14/analog.pdf": 4041,
	"./lectures/summer14/fpga_avi.pdf": 9429,
	"./lectures/summer14/img_process.pdf": 4903,
	"./lectures/summer14/rpi_lec.pdf": 8699,
	"./lectures/takneek 14/Introduction to FPGA_AVItakneek.pdf": 8438,
	"./lectures/takneek 14/lecture1.pdf": 2629,
	"./lectures/takneek 16/lecture1.pdf": 4836,
	"./lectures/takneek11/FpgaExamples2.rar": 5042,
	"./lectures/takneek11/Verilog1.pdf": 6286,
	"./lectures/takneek11/Verilog2.pdf": 495,
	"./lectures/takneek11/bluetooth_datasheet.pdf": 8909,
	"./lectures/takneek11/bluetooth_lec.pdf": 8938,
	"./lectures/takneek11/embedded.m": 6549,
	"./lectures/takneek12/apptics.pdf": 909,
	"./lectures/takneek12/electromania.pdf": 8364,
	"./lectures/takneek12/embedded.pdf": 9286,
	"./lectures/takneek12/fpga.pdf": 6948,
	"./lectures/techkriti12/ecdc_electromania.pdf": 9126,
	"./lectures/techkriti12/intro_mcu.pdf": 6727,
	"./lectures/techkriti12/lcd_and_interrupts.pdf": 4005,
	"./lectures/techkriti12/opencv.pdf": 3382,
	"./lectures/techkriti12/timers_and_interrupts.pdf": 4875,
	"./lectures/techkriti13/Introduction_to_mcu.pdf": 781,
	"./lectures/techkriti13/Timers_and_Interrupts.pdf": 4275,
	"./lectures/techkriti13/fpga1.pdf": 9308,
	"./lectures/techkriti13/fpga2.pdf": 6781,
	"./lectures/techkriti14/FPGA Design Challenge1.pdf": 1063,
	"./lectures/techkriti14/FPGA Design Challenge2.pdf": 2470,
	"./lectures/techkriti14/MCU.pdf": 2490,
	"./lectures/techkriti14/Timers and Interrupts1.pdf": 8977,
	"./projects": 4778,
	"./projects.json": 4778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2114;